import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { NoveltyCheckReportContext } from '../novelty-check-report-context';
import { NoveltyCheckReportState } from '../novelty-check-report-state';
import { Logger } from '@patsnap/tahiti-core';
import { NoveltyCheckTaskStep } from '@/domains/novelty-check-report/enums';
import { NoveltyCheckTaskStatusModel } from '@/domains/novelty-check-report/models/novelty-check-task-status-model';
import { ComplexRetrievalService } from '../../complex-retrieval-service';
import { NoveltyCheckReportTitleService, RetrievalElementsService, TechFeaturesService } from '../../retrieval-result-report-service';
import { NoveltyCheckTaskStatusService } from '../../task-status-service';
import { SummaryTechFeaturesService } from '../../summary-tech-features-service';

@injectable()
export class SearchFinishedState implements NoveltyCheckReportState {
    // eslint-disable-next-line max-params
    constructor(
        @inject(Logger)
        private readonly _logger: Logger,
        @inject(SummaryTechFeaturesService)
        private readonly _summaryTechFeatureService: SummaryTechFeaturesService,
        @inject(NoveltyCheckReportTitleService)
        private readonly _noveltyCheckReportTitleService: NoveltyCheckReportTitleService,
        @inject(TechFeaturesService)
        private readonly _techFeaturesService: TechFeaturesService,
        @inject(ComplexRetrievalService)
        private readonly _complexRetrievalService: ComplexRetrievalService,
        @inject(NoveltyCheckTaskStatusModel)
        private readonly _noveltyCheckTaskStatusModel: NoveltyCheckTaskStatusModel,
        @inject(RetrievalElementsService)
        private readonly _retrievalElementsService: RetrievalElementsService,
        @inject(NoveltyCheckTaskStatusService)
        private readonly _noveltyCheckTaskStatusService: NoveltyCheckTaskStatusService,
    ) { }

    async enter(context: NoveltyCheckReportContext): Promise<void> {
        // await this._noveltyCheckTaskStatusService.pullTaskStatus();
        // 进入<检索>状态的逻辑
        this._logger.info('进入<检索>状态');
        this._switchTaskStep(NoveltyCheckTaskStep.SEARCH_FINISHED);
        await this._complexRetrievalService.search();
        await Promise.all([
            // this._summaryTechFeatureService.pullSummary(),
            // 获取新颖性报告名称
            // this._noveltyCheckReportTitleService.pullNoveltyCheckReportTitle(),
            // 获取技术特征
            // this._techFeaturesService.pullTechFeatures(),
            // 获取搜索结果
            // this._complexRetrievalService.search(),
            // 获取检索要素
            // this._retrievalElementsService.pullRetrievalElements(),
        ]);
        // 检索结束后需要自动进入专利确认状态
        // await this.handleNext(context);
    }

    async handleNext(context: NoveltyCheckReportContext): Promise<void> {
        await this._actionsBeforeNext();
        // 从<检索>状态进入结果状态
        const resultState = context.getState(NoveltyCheckTaskStep.PATENT_CONFIRM);
        context.transitionTo(resultState);
    }

    async handlePrevious(context: NoveltyCheckReportContext): Promise<void> {
        // 返回技术特征识别状态
        const techFeatureState = context.getState(NoveltyCheckTaskStep.NOVELTY_SEARCH_TECH_FEATURE);
        await context.transitionTo(techFeatureState);
    }

    private async _actionsBeforeNext() {
        this._noveltyCheckTaskStatusModel.update(state => {
            state.taskStep = NoveltyCheckTaskStep.REPORT_CREATED;
            return state;
        });
    }

    private _switchTaskStep(step: NoveltyCheckTaskStep) {
        this._noveltyCheckTaskStatusModel.update(state => {
            state.taskStep = step;
            return state;
        });
    }
}
